import {
  REVIEW_PROMPT_CAPTERRA_MODAL_TITLE,
  REVIEW_PROMPT_CAPTERRA_TYPEFORM_ID,
  REVIEW_PROMPT_G2_MODAL_TITLE,
  REVIEW_PROMPT_G2_TYPEFORM_ID,
  ReviewPromptPlatform,
} from '@shared/core/billing'
import { GetProfileResponseDto } from '@shared/core/users'

export function getG2CapterraReviewModalContent(reviewPlatform: ReviewPromptPlatform) {
  if (reviewPlatform === 'g2') {
    return {
      formId: REVIEW_PROMPT_G2_TYPEFORM_ID,
      title: REVIEW_PROMPT_G2_MODAL_TITLE,
    }
  }

  return {
    formId: REVIEW_PROMPT_CAPTERRA_TYPEFORM_ID,
    title: REVIEW_PROMPT_CAPTERRA_MODAL_TITLE,
  }
}

export function buildG2CapterraReviewHiddenFields(profile: GetProfileResponseDto) {
  return {
    id: profile.id,
    email: profile.email,
    name: profile.full_name,
    usage_mode: profile.usage_mode,
  }
}
